<template>
  <div
      class="vacancy-card-action"
      :class="{
      _attention: vacancy[1].quantity < 5,
      _disabled: vacancy[1].quantity === 0
    }"
  >
    <div class="vacancy-card-action__col _places">
      <div class="vacancy-card-action__label">{{ $tVacancies('Places') }}</div>
      <div class="vacancy-card-action__places">{{ (vacancy[1] || {}).quantity }}</div>
    </div>

    <template v-if="isDisabled">
      <div class="vacancy-card-action__col  _no-vacant-places-text">
        <div class="vacancy-card-action__label">
          {{ $tVacancy('Now not available places') }}<br>
          {{ $tVacancy('subscribe on vacancy') }}
        </div>
      </div>

      <div class="vacancy-card-action__col _responded">
        <div class="vacancy-card-action__label">
          <span>
            {{ $tVacancy('Views') }} <b>{{ vacancy.views }}</b>
          </span>
        </div>

        <template v-if="vacancy.sended">
          <router-link-modified :to="{ name: 'account-my-vacancies'}"
                                class="vacancy-card-action__btn  base-btn--blue-dark base-btn d-xs-none">
            <span class="base-btn__text">{{ $tVacancy('My responds') }}</span>
          </router-link-modified>
          <router-link-modified :to="{ name: 'account-my-vacancies'}"
                                class="vacancy-card-action__btn base-btn--blue-dark base-btn d-none d-xs-inline-flex">
            <span class="base-btn__text">{{ $tVacancy('My responds') }}</span>
          </router-link-modified>
        </template>

        <template v-else-if="isEmployee">
          <button type="button"
                  @click.prevent="subscribeOnVacancy"
                  class="vacancy-card-action__btn  base-btn--blue-dark base-btn d-xs-none">
            <span class="base-btn__text">{{ $tVacancy('Report about new vacancies') }}</span>
          </button>

          <button type="button"
                  @click.prevent="subscribeOnVacancy"
                  class="vacancy-card-action__btn base-btn--blue-dark base-btn d-none d-xs-inline-flex">
            <BaseSvg
                name="ico-arrow-light"
                style="width: .6rem; height: .9rem"
            />
          </button>
        </template>

        <template v-else-if="isLogged">
          <button type="button"
                  @click.prevent="openLoginAsUser"
                  class="vacancy-card-action__btn  base-btn--blue-dark base-btn d-xs-none">
            <span class="base-btn__text">{{ $tVacancy('Report about new vacancies') }}</span>
          </button>

          <button type="button"
                  @click.prevent="openLoginAsUser"
                  class="vacancy-card-action__btn base-btn--blue-dark base-btn d-none d-xs-inline-flex">
            <BaseSvg
                name="ico-arrow-light"
                style="width: .6rem; height: .9rem"
            />
          </button>
        </template>

        <template v-else>
          <router-link-modified :to="{name: 'auth'}"
                                class="vacancy-card-action__btn  base-btn--blue-dark base-btn d-xs-none">
            <span class="base-btn__text">{{ $tVacancy('Report about new vacancies') }}</span>
          </router-link-modified>

          <router-link-modified :to="{name: 'auth'}"
                                class="vacancy-card-action__btn base-btn--blue-dark base-btn d-none d-xs-inline-flex">
            <BaseSvg
                name="ico-arrow-light"
                style="width: .6rem; height: .9rem"
            />
          </router-link-modified>
        </template>
      </div>
    </template>

    <template v-else>
      <div class="vacancy-card-action__col _timer">
        <div class="vacancy-card-action__label">{{ $tVacancy('Still relevant') }}</div>
        <TimerSmall
            class="vacancy-card-action__timer"
            :end-time="(vacancy[1] || {}).relevant"
        />
      </div>

      <div class="vacancy-card-action__col _responded">
        <div class="vacancy-card-action__label">
          <span>
            {{ $tVacancy('Views') }} <b>{{ vacancy.views }}</b>
          </span>
        </div>

        <template v-if="vacancy.sended">
          <router-link-modified :to="{ name: 'account-my-vacancies'}"
                                class="vacancy-card-action__btn  base-btn--blue-dark base-btn d-xs-none">
            <span class="base-btn__text">{{ $tVacancy('My responds') }}</span>
          </router-link-modified>
          <router-link-modified :to="{ name: 'account-my-vacancies'}"
                                class="vacancy-card-action__btn base-btn--blue-dark base-btn d-none d-xs-inline-flex">
            <span class="base-btn__text">{{ $tVacancy('My responds') }}</span>
          </router-link-modified>
        </template>

        <template v-else>
          <router-link-modified
              type="button"
              class="vacancy-card-action__btn  base-btn--green base-btn d-xs-none"
              :to="{ name: 'vacancy', params: { vacancyId: (vacancy[1] || {}).slug } }"
          >
            <span class="base-btn__text">{{ $tVacancy('More details') }}</span>
          </router-link-modified>

          <router-link-modified
              type="button"
              class="vacancy-card-action__btn base-btn--green base-btn d-none d-xs-inline-flex"
              :to="{ name: 'vacancy', params: { vacancyId: (vacancy[1] || {}).slug } }"
          >
            <BaseSvg
                name="ico-arrow-light"
                style="width: .6rem; height: .9rem"
            />
          </router-link-modified>
        </template>
      </div>
    </template>


  </div>
</template>

<script>
  import TimerSmall from '@/components/TimerSmall';
  import parseDate from '@/helpers/parseDate'
  import {EMPLOYEE} from '@/constants/usersTypes'

  export default {
    name: 'VacancyCardAction',

    components: {
      TimerSmall
    },

    props: {
      vacancy: {
        type: Object,
        required: true
      }
    },
    computed: {
      isLogged() {
        return this.$store.getters['user/isLogged']
      },
      isEmployee() {
        return this.isLogged
            && this.$store.state.user.profile.user_type === EMPLOYEE
      },
      isDisabled() {
        if (!this.vacancy[1].relevant) return true // ?
        if (!this.vacancy[1].quantity) return true

        const relevantDate = parseDate(this.vacancy[1].relevant)
        return new Date() > relevantDate //ok
      },
    },
    methods: {
      subscribeOnVacancy() {
        this.$vModal.open('subscribe-on-vacancy', {
          vacancyId: this.vacancy.ID
        })
      },
      openLoginAsUser() {
        this.$vModal.open('auth-as-employee-for-subscribe-on-vacancy', {
          vacancyId: this.vacancyId
        })
      }
    }
  };
</script>
